import { Divider } from "primereact/divider";

import {
  labelLaPasswordDeveContenere,
  labelAlmenoOttoCaratteri,
  labelAlmenoUnaLetteraMinuscola,
  labelAlmenoUnaLetteraMaiuscola,
  labelAlmenoUnNumero,
} from "../../_constants";

export const FooterSuggestionsPassword = () => {
  return (
    <>
      <Divider className="margin-top-14 margin-bottom-14" />
      <p className="margin-top-2">{labelLaPasswordDeveContenere}</p>
      <ul className="padd-left-24 margin-bottom-0">
        <li className="footer-suggestion-p">{labelAlmenoOttoCaratteri}</li>
        <li className="footer-suggestion-p">
          {labelAlmenoUnaLetteraMinuscola}
        </li>
        <li className="footer-suggestion-p ">
          {labelAlmenoUnaLetteraMaiuscola}
        </li>
        <li className="footer-suggestion-p ">{labelAlmenoUnNumero}</li>
      </ul>
    </>
  );
};
